export enum EDealershipsQueryKey {
  DEALERSHIPS = 'DEALERSHIPS',
  DEALERSHIP = 'DEALERSHIP',
}
